// App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './Translations/LenguageContext';
import './App.css';
import './Platform.css';
import './AppMobile.css';

// Website imports
import ScrollToTop from './Functions/ScrollToTop';
import MainFrameHome from './Website/Home/MainFrameHome';
import Login from './Website/LoginRegister/Login';
import Register from './Website/LoginRegister/Register';
import Privacy_Policy from './Policies/PrivacyPolicy';
import Terms_And_Conditions from './Policies/TermsConditions';
import Cookie_Policy from './Policies/CookiesPolicy';
import Legal_Notes from './Policies/LegalNotes';
import ControlPanel from './Platform/ControlPanel/ControlPanel';
import SharedFile from './Platform/SharedSpaces/SharedFile';
import Logo from './Logo/Logo';
import HelpCenter from './Website/Help/HelpCenter';
import SuccessfulHelp from './Website/Help/SuccessfulHelp';
import ProjectPanel from './Platform/ProjectPanel/ProjectPanel';
import MainDocumentation from './Documentation/MainDocumentation';
import Invoice from './Platform/Billing/invoice';
import LoginPcPage from './Website/LoginRegister/LoginPCPage';
import MainCodespaces from './Platform/Codespaces/MainCodespaces';

// Analytics import (make sure analytics.js is inside src/)
import { logPageView } from "./analytics";
import InitializingPage from './Platform/Projects/InitializeLoadingPage';

// --- Analytics wrapper for useLocation ---
const AnalyticsWrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return children;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<MainFrameHome />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/mobile_device" element={<LoginPcPage />} />
    <Route path="/help-center" element={<HelpCenter />} />
    <Route path="/successful-help-request" element={<SuccessfulHelp />} />
    <Route path="/privacy-policy" element={<Privacy_Policy />} />
    <Route path="/terms-and-conditions" element={<Terms_And_Conditions />} />
    <Route path="/cookie-policy" element={<Cookie_Policy />} />
    <Route path="/legal-notes" element={<Legal_Notes />} />
    <Route path="/dev-docs/:doc_page" element={<MainDocumentation />} />

    {/* Platform */}
    <Route path="/control_panel/*" element={<ControlPanel />} />
    <Route path="/project_panel/:project_id/*" element={<ProjectPanel />} />
    <Route path="/sf/*" element={<SharedFile />} />
    <Route path="/logo" element={<Logo />} />
    <Route path="/invoice/:inv_id" element={<Invoice />} />

    <Route path="/initialize_loading/:user_id/:project_id" element={<InitializingPage />} />


    {/* Codespaces */}
    <Route path="/:project_id/codespace" element={<MainCodespaces />} />
  </Routes>
);

// --- Main App component ---
const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <AnalyticsWrapper>
          <ScrollToTop />
          <AppRoutes />
        </AnalyticsWrapper>
      </Router>
    </LanguageProvider>
  );
};

export default App;
